import "firebase/auth";

import { FirebaseApp, initializeApp } from "firebase/app";
import { result as firebaseConfig } from "../environment/firebase-config.json";

export class FirebaseService {
    private firebaseApp: FirebaseApp;

    public constructor() {
        this.firebaseApp = initializeApp(firebaseConfig);
    }

    public getApp = () => this.firebaseApp;
}
